export class User {
  constructor(public username: string, public password: string, public rememberMe: boolean) {}
}



// WEBPACK FOOTER //
// ./src/app/models/login-users.ts